import { Divider, Stack, Typography } from '@mui/material';
import { Download } from './Download';
import { MoreInfoAndAction } from './MoreInfoAndAction';
import { DocumentReceivedOrSent } from './DocumentReceivedOrSent';
import { IsNew } from './IsNew';
import { format } from 'date-fns';
import { shorterDateFormat } from 'Config';
import { IExtendedDocument } from 'Context/DocumentsContext';

interface IDocumentDetail {
  data: IExtendedDocument;
}

export const DocumentDetail = ({ data }: IDocumentDetail) => {
  return (
    <>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          height: '90px',
          position: 'relative',
        }}
      >
        <Typography
          variant='body2'
          sx={{
            width: '350px',
          }}
        >
          {data.name}
        </Typography>
        <Stack
          direction='row'
          alignItems='center'
          gap='10px'
          sx={{
            width: '220px',
          }}
        >
          <Typography
            variant='body6'
            width='100px'
            sx={{
              color: '#656F8B',
              textAlign: 'center',
            }}
          >
            {data.subjectName}
          </Typography>
          <Divider
            orientation='vertical'
            sx={{ borderColor: '#A6ACBC', height: '16px' }}
          />
          <Typography
            variant='body6'
            sx={{
              color: '#656F8B',
            }}
          >
            {format(new Date(data.documentDate), shorterDateFormat)}
          </Typography>
        </Stack>
        <DocumentReceivedOrSent isSentToUser={data.isSentToUser} />
        <Stack
          direction='row'
          gap='32px'
          sx={{
            width: 'fit-content',
          }}
        >
          <Download docId={data.id} docType={data.typeId} docName={data.name} />
          <MoreInfoAndAction data={data} />
        </Stack>
        <IsNew docDate={data.documentDate} />
      </Stack>
      <Divider
        sx={{
          borderColor: '#A6ACBC',
          opacity: '50%',
        }}
      />
    </>
  );
};
